import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["target"]

  static values = {
    clickOnConnect: Boolean
  }

  connect() {
    if (this.clickOnConnectValue ) {
      this.click()
    }
  }

  click(_event) {
    if (!this.targetTarget) { return }

    this.targetTarget.click()
  }
}
